<template>
  <div class="drop-down pointer">
    <div
      class="d-flex justify-space-between align-center"
      @click="show = !show"
    >
      <div class="value">{{ value }}</div>
      <v-icon>keyboard_arrow_down</v-icon>
    </div>
    <div class="drop-down-list" v-if="show">
      <div
        v-for="item in items"
        :key="item"
        class="drop-down-list-item"
        @click="change(item)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      default: null,
      type: String
    },
    items: {
      default: () => {
        return [];
      },
      type: Array
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    change(item) {
      this.$emit("input", item);
      this.show = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.drop-down {
  position: relative;
  .value {
    color: #7557e5;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    font-family: Gotham-Medium;
  }
  .drop-down-list {
    position: absolute;
    background: #fff;
    .drop-down-list-item {
      padding: 2px 10px;
    }
  }
}
</style>
